module.exports = __webpack_public_path__ + "img/green-title-en.10f0e580.png";